<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page1">
</a><a id="page3">
<div class="titlePage">
<h2 class="titlePageTitle">GOD’S<br/>SECRETARIES</h2>
<h3 class="titlePageSubtitle">
<em class="italic">The Making of the King James Bible</em>
</h3>
<p class="titlePageAuthor">ADAM NICOLSON</p>
<p class="titlePagePublisher"><img alt="logo" src="logo.jpg"/></p>
</div>
</a></div><a id="page3">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// godssecretaries.vue?2257173c